// extracted by mini-css-extract-plugin
export default {"innerInput":"MaskInput_innerInput__O+Ylb","borderSuffix":"MaskInput_borderSuffix__tpNK6","disabled":"MaskInput_disabled__YI4Ni"};